import { render, staticRenderFns } from "./FeedbackTemplate.vue?vue&type=template&id=7344b558&scoped=true&"
import script from "./FeedbackTemplate.vue?vue&type=script&lang=js&"
export * from "./FeedbackTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTemplate.vue?vue&type=style&index=0&id=7344b558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7344b558",
  null
  
)

export default component.exports